import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import {
    Barlow,
    Barlow_Condensed,
    Geist_Mono,
    Oswald
} from 'next/font/google'

const sans = Barlow({
    subsets: ['latin'],
    weight: ['400']
})

const heading = Barlow_Condensed({
    subsets: ['latin'],
    weight: ['600', '700', '800']
})

// Oswald Bold, used only for the countdown numbers.
const numbers = Oswald({
    subsets: ['latin'],
    weight: '700'
})

// Not used on the page, so it is not preloaded and only downloads if something ever renders in mono.
const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-numbers:${numbers.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
